import React, { useEffect, useMemo } from "react";
import { Table } from "../table";
import { useStore } from "../../store/appStore";
import moment from "moment";



export default function ListadoFacturasCompra() {
  const { loadCompras, comprasStore } = useStore();
  const data = useMemo(() => comprasStore, [comprasStore]);

  const columns = useMemo(
    () => [
      { Header: "Id", accessor: "id" },
      { Header: "Numero", accessor: "1" },
      { Header: "Referencia", accessor: "ref" },
      {
        Header: "Fecha", accessor: d => {
          return moment(d.fecha?.toDate())
            .local()
            .format("DD-MM-YYYY");
        }
      },
      { Header: "Nombre", accessor: "proveedor.nombre" },
      { Header: "Total", accessor: d =>{
        return `${parseFloat(d.total).toFixed(2).toString().replace('.', ',')} €`
      }
     },
      { Header: "Total con IVA", accessor: d =>{
        return `${parseFloat(d.totalConIva).toFixed(2).toString().replace('.', ',')} €`
      } },
    ],
    []
  );
  useEffect(() => {
    loadCompras();
  }, []);
  return <Table columns={columns} data={data} />;
}
